import React, { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Root from './root/Root';

import configureStore from './store';
import './index.css';

const store = configureStore();

// Make store accessible globally for testing (Playwright)
if (typeof window !== 'undefined') {
    (window as any).store = store;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLDivElement);

root.render(
    <Provider store={store}>
        <BrowserRouter>
            <StrictMode>
                <Root />
            </StrictMode>
        </BrowserRouter>
    </Provider>
);
